module.exports = __webpack_public_path__ + "static/media/hero-image-1.7b03221b.png";